import { Link } from 'react-router-dom';
import { Badge } from 'shared/components/ui/Badge';
import { Avatar } from 'shared/components/ui/Avatar';
import { ROUTES } from 'shared/constants/routes';
import { greetingForHour } from 'shared/utils/greeting';
import { PLAYER_SPORT_LEVELS } from 'modules/jogador/profile/content';

interface GreetingHeaderProps {
  name: string;
}

export function GreetingHeader({ name }: GreetingHeaderProps) {
  const greeting = greetingForHour(new Date().getHours());
  const mainSport = PLAYER_SPORT_LEVELS[0];

  return (
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm text-ink-secondary">{greeting},</p>
        <h1 className="font-heading text-2xl font-bold text-ink">{name}</h1>
      </div>

      <div className="flex items-center gap-3">
        <Badge tone="accent">
          {mainSport.sport} · {mainSport.level}
        </Badge>
        <Link to={ROUTES.PROFILE}>
          <Avatar name={name} />
        </Link>
      </div>
    </div>
  );
}
